import { render, staticRenderFns } from "./DifNavisionNavixyReport.vue?vue&type=template&id=04b324a4&scoped=true&"
import script from "./DifNavisionNavixyReport.vue?vue&type=script&lang=js&"
export * from "./DifNavisionNavixyReport.vue?vue&type=script&lang=js&"
import style0 from "./DifNavisionNavixyReport.vue?vue&type=style&index=0&id=04b324a4&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "04b324a4",
  null
  
)

export default component.exports